// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"ae66fe66","213":"44285854","238":"a0d9c5be","239":"a5ce46c0","450":"80a1255b","455":"1154c543","557":"6f6fb8b0","762":"d6e85650","867":"f27bd732"}[chunkId] + ".chunk.js";
};